import {intlShape, utils} from '@wallaby-ui/core';
import {isNil, isString} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';

import styles from './IconFormatter.less';

class IconFormatter extends React.PureComponent {
  render() {
    const {intl, value} = this.props;
    let ownValue;
    if (!isNil(value)) {
      if (value.value) {
        ownValue = JSON.parse(value.value);
      } else if (isString(value)) {
        ownValue = JSON.parse(value);
      }
    }
    if (!isNil(ownValue)) {
      if (ownValue.icon) {
        const label = ownValue.tooltip
          ? utils.TranslateUtils.translate(ownValue.tooltip, intl)
          : undefined;
        return (
          <div className={styles.dlIconFormatter}>
            {ownValue.icon && (
              <i
                title={label}
                className={ownValue.icon}
                style={{
                  color: ownValue.color ? ownValue.color : '#dedede',
                }}
              />
            )}
          </div>
        );
      }
    }
    return '';
  }
}

IconFormatter.displayName = 'IconFormatter';

IconFormatter.propTypes = {
  intl: intlShape.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.objectOf(PropTypes.any),
    PropTypes.string,
  ]),
};

IconFormatter.defaultProps = {
  value: undefined,
};

export default injectIntl(IconFormatter);
